<template>
    <v-footer v-if="!loomisStyle" app v-bind="$attrs">
        <v-row class="mx-2">
            <img class="d-none d-lg-block mx-2" src="@/assets/cima_logo.svg" width="20" alt="Cima logo" />
            <span class="d-none d-md-block mx-2">CIMA</span>
            <div class="flex-grow-1" />
            <span>C-Link v{{ version }}</span>
            <span class="d-none d-md-block mx-2">&copy; 2011-{{ new Date().getFullYear() }}</span>
        </v-row>
    </v-footer>
    <v-footer v-else style="background-image: url(assets/images/darkdenim3.png); background-repeat: repeat-x; color: #9b9b9b">
        <v-container fluid class="pa-0 text-center">
            <v-row no-gutters justify="center">
                <v-col cols="12" lg="11" xl="7">
                    <v-row justify="center">
                        <v-col cols="1">&nbsp;</v-col>
                        <v-col cols="12" md="2">
                            <a style="color: white; text-decoration: none" href="https://www.loomis.us/about-us" target="_blank" rel="noopener noreferrer"> About Us </a>
                        </v-col>
                        <v-col cols="12" md="2">
                            <a style="color: white; text-decoration: none" href="https://www.loomis.us/contact-us" target="_blank" rel="noopener noreferrer"> Contact Us </a>
                        </v-col>
                        <v-col cols="12" md="2" xl="3">
                            <a style="color: white; text-decoration: none" href="https://www.loomis.us/resources/press-releases-news" target="_blank" rel="noopener noreferrer">
                                News and Anouncements
                            </a>
                        </v-col>
                        <v-col cols="12" md="2">
                            <a style="color: white; text-decoration: none" href="https://www.loomis.us/products" target="_blank" rel="noopener noreferrer">
                                Product and Services
                            </a>
                        </v-col>
                        <v-col cols="12" md="2">
                            <a style="color: white; text-decoration: none" href="https://www.loomis.us" target="_blank" rel="noopener noreferrer"> Loomis US </a>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div class="mb-2">
                <div>
                    <small style="font-size: 0.875em; font-weight: 400">
                        Copyright © {{ new Date().getFullYear() }} Loomis. All rights reserved. Please read our
                        <a style="color: white; text-decoration: none" href="https://www.loomis.us/privacy-policy" target="_blank" rel="noopener noreferrer"> Privacy Policy </a>
                        and <a style="color: white; text-decoration: none" href="https://www.loomis.us/terms-use" target="_blank" rel="noopener noreferrer"> Terms of Use </a>.
                    </small>
                </div>
            </div>
        </v-container>
    </v-footer>
</template>

<script>
export default {
    props: {
        loomisStyle: Boolean,
    },
    computed: {
        version() {
            return process.env.VERSION;
        },
    },
};
</script>
